import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Landing from "@/pages/Landing";
import Portfolio from "@/pages/Portfolio";
import ManageSubscription from "@/pages/ManageSubscription";
import PaymentCancel from "@/pages/PaymentCancel";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: { offset: -64 } });
    window.__lenis = lenis;
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    const id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#06120E] min-h-screen">
      <div className="noise-overlay" aria-hidden="true" />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/multipolar" element={<Landing />} />
          <Route path="/openaccess" element={<Portfolio />} />
          <Route path="/gerer-mon-abonnement" element={<ManageSubscription />} />
          <Route path="/gerer-mon-abonnement/confirmation" element={<ManageSubscription sent />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
